/*
  GTH free sample picker — behavior (26 Aug 2026)

  Loaded globally from snippets/scoop-bag-auto-add.liquid (rendered in
  layout/theme.liquid on every page), NOT from the picker snippet itself.
  The picker markup arrives via AJAX-injected HTML in the cart drawer and
  the cart page's data-line-items refresh, and injected <script> tags never
  execute — an inline script left the drawer's picker buttons dead. Markup
  and config live in snippets/gth-free-sample-picker.liquid; this file owns
  every behavior and reads config lazily from the [data-gth-fsp-config]
  JSON tag so drawer re-renders always give it current state.

  Server truth: the "GTH Scoop Bag Pricing" cart transform zeroes valid
  _free_sample lines. This file only adds choices and removes lines the
  function refused (final_price != 0), keeps picks within entitlement, and
  refreshes the display: full reload on the cart page, theme cart events
  (the scoop system's pattern) everywhere else so the drawer re-renders.
*/
(function () {
  if (window.__gthFspInit) return;
  window.__gthFspInit = true;

  var HDR = 'X-Free-Sample';
  var busy = false;
  var timer = null;

  function rootEl() {
    return document.querySelector('[data-gth-fsp]');
  }

  function cfg() {
    var el = document.querySelector('[data-gth-fsp-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function post(url, payload) {
    var h = { 'Content-Type': 'application/json' };
    h[HDR] = '1';
    return fetch(url, { method: 'POST', headers: h, body: JSON.stringify(payload) });
  }

  function readCart() {
    var h = {};
    h[HDR] = '1';
    return fetch('/cart.js', { headers: h }).then(function (r) { return r.json(); });
  }

  function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return Promise.resolve();
    }
    return readCart().then(function (cart) {
      if (window.GthCart && typeof GthCart.set === 'function') GthCart.set(cart);
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var ch = e.target.closest('[data-fsp-chip]');
    if (ch) {
      var sel = ch.getAttribute('data-fsp-chip');
      document.querySelectorAll('[data-fsp-chip]').forEach(function (c) {
        c.classList.toggle('gth-fsp__chip--on', c === ch);
      });
      document.querySelectorAll('.gth-fsp__card[data-fsp-genre]').forEach(function (card) {
        var g = card.getAttribute('data-fsp-genre');
        card.classList.toggle('gth-fsp__card--filtered', sel !== '' && g !== '' && g !== sel);
      });
      return;
    }
    var kt = e.target.closest('[data-fsp-keeper]');
    if (kt) {
      var f = document.getElementById('gth-fsp-keeper-form');
      if (f) {
        f.hidden = !f.hidden;
        kt.setAttribute('aria-expanded', String(!f.hidden));
        if (!f.hidden) {
          var ta = f.querySelector('textarea');
          if (ta) ta.focus();
        }
      }
      return;
    }
    var ka = e.target.closest('[data-fsp-keeper-add]');
    if (ka && !busy) {
      busy = true;
      var kform = ka.closest('.gth-fsp__keeper-form');
      var noteEl = kform && kform.querySelector('textarea');
      var note = noteEl ? noteEl.value : '';
      var props = { _free_sample: '1' };
      if (note && note.trim()) props['Preferences'] = note.trim().slice(0, 200);
      post('/cart/add.js', { items: [{ id: Number(ka.getAttribute('data-fsp-keeper-add')), quantity: 1, properties: props }] })
        .then(function () { return refresh(); })
        .then(function () { busy = false; }, function () { busy = false; });
      return;
    }
    var btn = e.target.closest('[data-fsp-add]');
    if (!btn || btn.disabled || busy) return;
    busy = true;
    post('/cart/add.js', { items: [{ id: Number(btn.getAttribute('data-fsp-add')), quantity: 1, properties: { _free_sample: '1' } }] })
      .then(function () { return refresh(); })
      .then(function () { busy = false; }, function () { busy = false; });
  });

  function activeTier(cart) {
    var C = cfg() || {};
    var rate = (C.rates || {})[cart.currency] || 0;
    var eligible = 0;
    cart.items.forEach(function (it) {
      if (it.properties && (it.properties._free_sample || it.properties._scoop_variant)) return;
      eligible += it.original_line_price;
    });
    var idx = 0, picks = 0;
    if (rate > 0) {
      (C.tiers || []).forEach(function (t, i) {
        if (eligible >= Math.round(t.threshold * 100 * rate)) { idx = i + 1; picks = t.picks; }
      });
    }
    return { idx: idx, picks: picks };
  }

  function enforce() {
    if (busy) return;
    busy = true;
    readCart().then(function (cart) {
      var tier = activeTier(cart);
      var samples = cart.items.filter(function (it) { return it.properties && it.properties._free_sample; });
      var ops = [];
      var kept = 0;
      samples.forEach(function (it) {
        var over = tier.idx === 0 || kept >= tier.picks || it.final_price !== 0;
        if (over) {
          ops.push({ id: it.key, quantity: 0 });
        } else {
          kept++;
          if (it.quantity !== 1) ops.push({ id: it.key, quantity: 1 });
        }
      });
      var root = rootEl();
      var stale = root && (String(tier.idx) !== root.getAttribute('data-fsp-active') || String(kept) !== root.getAttribute('data-fsp-chosen'));
      if (!ops.length) {
        busy = false;
        if (stale) refresh();
        return;
      }
      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () { return post('/cart/change.js', op); });
      });
      chain.then(function () { return refresh(); }).then(function () { busy = false; }, function () { busy = false; });
    }, function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(enforce, 200);
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var internal = init && init.headers && init.headers[HDR];
    var p = origFetch.apply(this, arguments);
    if (!internal && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && /\/cart\/(add|change|update|clear)/.test(String(url))) {
      this.addEventListener('load', schedule);
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('theme:cart:change', function () {
    if (!busy) schedule();
  });

  function onLoad() {
    var r = rootEl();
    if (r && r.hasAttribute('data-fsp-broken')) schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }
})();
